import {
    ComponentElements,
    ComponentInjector,
    ComponentObject,
    ComponentService,
    UIComponent,
    ComponentSelectors,
} from '@atypon/ui-utils';

class Texts extends ComponentObject {
    cssVariableName = '--header-height';
    headerSelector = '.header';
}

class ClassList extends ComponentObject { }

class Selectors extends ComponentSelectors { }

class Elements extends ComponentElements<Selectors> { }

interface Header extends ComponentService<Selectors, Elements, ClassList, Texts> { }

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class Header implements UIComponent {
    constructor(readonly wrapper: HTMLElement) { }

    initialize(): void {
        this.control();
        this.addEventListeners();
    }

    addEventListeners(): void {}

    control(): void {
        const root = document.documentElement;
        const header = document.querySelector(this.texts.headerSelector) as HTMLElement;
    
        if (typeof root.style.setProperty === 'undefined') {
            console.warn('CSS custom properties not supported in this browser');
            return;
        }
    
        this.updateHeaderHeightCssVar(header, root);
    }

    private updateHeaderHeightCssVar(header: HTMLElement, root: HTMLElement): void {
        const headerHeight = header.getBoundingClientRect().bottom;
        
        root.style.setProperty(this.texts.cssVariableName, `${headerHeight}px`);
    }
}

export default Header;

export {
    Elements as HeaderElements,
    Selectors as HeaderSelectors,
    ClassList as HeaderClassList,
    Texts as HeaderTexts
}